import { ethers } from 'ethers'

import { PublicKey } from '@solana/web3.js'

import { ChainId } from '@src/configs/chainInfo'
import { Address } from '@src/types/token'

export const validateDestinationAddress = (address: Address | undefined, networkId: number): boolean => {
    if (!address) return false

    // Solana address validation - using the same regex pattern from truncateAddress utility
    if (networkId === ChainId.Solana) {
        return validateSolAddress(address)
    }

    // Tron address validation
    if (networkId === ChainId.Tron) {
        const tronAddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/
        return tronAddressRegex.test(address)
    }

    // EVM address validation
    return validateEvmAddress(address)
}

// Validate EVM address
export function validateEvmAddress(address: string) {
    return ethers.isAddress(address)
}

// Validate Solana address
export function validateSolAddress(address: string) {
    try {
        const pubkey = new PublicKey(address)
        const isSolana = PublicKey.isOnCurve(pubkey.toBuffer())
        return isSolana
    } catch (error) {
        return false
    }
}
